import { render } from "./AcceptanceCriteria.vue?vue&type=template&id=555fbf64&scoped=true"
import script from "./AcceptanceCriteria.vue?vue&type=script&lang=js"
export * from "./AcceptanceCriteria.vue?vue&type=script&lang=js"

import "./AcceptanceCriteria.vue?vue&type=style&index=0&id=555fbf64&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-555fbf64"]])

export default __exports__